module.exports = __webpack_public_path__ + "static/leader5-0f8f7b14116b387e627c8d8d5f28592a.svg";